// extracted by mini-css-extract-plugin
export default {"TravelModeBtn":"TravelModeBtn_TravelModeBtn__xclcd","rotation":"TravelModeBtn_rotation__gyVCE"};